/**
 * Interstitial Sign-in
 *
 * Sends the member to the sign-in path when fragno's idme-button widget is
 * clicked. The widget only navigates to id.me origins, so the template gives it
 * no URL: it dispatches idme-button-click and this module navigates to the
 * path in data-href.
 *
 * Workaround for a fragno gap: idme-button has no label attribute, continue
 * variant or width control, and its shadow DOM exposes no part. Audited against
 * fragno 1.17.0 and fragno-next 2.3.0. Once the widget is upgraded, its inner
 * button fills the host (full width, like the fragno-button it replaces), and
 * data-label and data-accessible-name replace its visible text and aria-label.
 * The widget re-renders only when its observed attributes change, and the
 * template never changes them after load. The widget stays hidden (see
 * v2/_interstitial.scss) until data-adapted is set.
 */

const SIGNIN_SELECTOR = "idme-button[data-href]";

function adapt(widget) {
  try {
    const button = widget.shadowRoot.querySelector(".fragno-idme-button");
    button.style.width = "100%";
    if (!widget.dataset.label) return;

    widget.shadowRoot.querySelector(".fragno-idme-button__text").textContent =
      widget.dataset.label;
    button.setAttribute("aria-label", widget.dataset.accessibleName);
  } finally {
    // The stylesheet hides the widget until this runs, so the unadapted text and width never paint;
    // reveal it even when fragno's markup changed, since its own look still navigates.
    widget.dataset.adapted = "";
  }
}

export function initInterstitialSignin() {
  const widgets = document.querySelectorAll(SIGNIN_SELECTOR);

  widgets.forEach((widget) => {
    widget.addEventListener("idme-button-click", () => {
      window.location.assign(widget.dataset.href);
    });
  });

  return customElements.whenDefined("idme-button").then(() => {
    widgets.forEach(adapt);
  });
}
